module.exports = __webpack_public_path__ + "static/pp_nip-ed9462dc145e84cb32963d1be9d3a14e.gif";